module.exports = __webpack_public_path__ + "static/img/1_0022.04d7fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0022.jpg
// module id = lEi1
// module chunks = 0